import React, { useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
// @ts-ignore TODO: type this component
import OnImagesLoaded from 'react-on-images-loaded';
import { getEarlyAccessTrackingPhase, useEarlyAccessPhase } from '@browsing/plus';
import { getQueryParam } from '@browsing/utils';
import { useTrackPageView } from '@browsing/tracking';

import { getTrackingForTrafficSource } from '@client/helpers/tracking';
import MyLoungeWrapper from '@client/components/mylounge/mylounge-wrapper';
import { fetchFlashMessages } from '@client/redux/modules/flashMessage/actions';
import { saveTrackingData } from '@client/redux/modules/tracking/actions';
import {
    updateImagesLoaded,
    getTabs,
    hasOpenCampaigns as getHasOpenCampaigns,
    updateCategoryTabId,
    getCategoryTabId,
    getError as getMyLoungeError,
    getIsLoading,
    getEarlyAccessCampaigns,
} from '@client/redux/modules/mylounge';
import { fetchCategorySubline } from '@client/redux/modules/myloungeMetadata/actions';
import { getFlashMessages } from '@client/redux/modules/flashMessage/selectors';
import { CategoryTabIds } from '@client/components/mylounge/banner/constants';
import { Error } from '@client/components/error';
import { useMylounge } from '@client/components/mylounge/hooks';

import { useIsPlatformJourney } from '@client/components/mylounge/platform-journeys';
import { track } from '../helpers/tracking';
import { TRACK_DATA } from '../config/constants';
import { loadTrackData } from './common/routingHelpers';

export const MyLounge = () => {
    const params = useParams<{ categoryTabId: string }>();
    const dispatch = useDispatch();
    const tabs = useSelector(getTabs);
    const categoryTabId = useSelector(getCategoryTabId);
    const myLoungeError = useSelector(getMyLoungeError);
    const hasOpenCampaigns = useSelector(getHasOpenCampaigns);
    const isLoading = useSelector(getIsLoading);
    const flashMessages = useSelector(getFlashMessages);
    const isPlatformJourneyEnabled = useIsPlatformJourney();
    const { openCampaigns, upcomingCampaigns } = useSelector(getEarlyAccessCampaigns);
    const earlyAccessPhase = useEarlyAccessPhase(openCampaigns, upcomingCampaigns);

    // TODO: move to custom hook
    useEffect(() => {
        const newCategoryTabId = params.categoryTabId || CategoryTabIds.ALL;
        const isTabForIdPresent = !!tabs.find(tab => tab.id === newCategoryTabId);

        if (categoryTabId === newCategoryTabId && isTabForIdPresent) {
            return;
        }

        dispatch(
            updateCategoryTabId(
                isTabForIdPresent ? (newCategoryTabId as CategoryTabIds) : CategoryTabIds.ALL,
            ),
        );
    }, [categoryTabId, dispatch, params.categoryTabId, tabs]);

    // TODO: review if we need this functionality
    // NOTE: lets keep it for now,
    // needed to load active banner image in first place
    const onImagesLoaded = useCallback(() => {
        dispatch(updateImagesLoaded(true));
    }, [dispatch]);

    useTrackPageView({ earlyAccessPhase, page: 'mylounge', isLoaded: true });

    useEffect(() => {
        // TODO: validate this part, translations.errors currently is empty
        // const error = extractError(myLoungeError);
        // const error = myLoungeError;
        // if (error) {
        // if (error.error.code && translations.errors[error.error.code]) {
        //     dispatch(showHeaderFlashMessage({
        //         type: FLASH_MESSAGE_TYPE_ERROR,
        //         message: translations.errors[error.error.code],
        //     }));
        // }

        // return;
        // }
        dispatch(fetchFlashMessages());
        dispatch(fetchCategorySubline());

        const trafficSource = getQueryParam('trafficSource');
        loadTrackData().then(data => {
            dispatch(saveTrackingData(data));
            track(TRACK_DATA, {
                ...data,
                ...getTrackingForTrafficSource(trafficSource),
                dark_mode: !!(
                    window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
                ),
                isSeamlessJourney: isPlatformJourneyEnabled ? '1' : '0',
                earlyAccessPhase: getEarlyAccessTrackingPhase({ earlyAccessPhase }),
            });
        });
    }, [dispatch, earlyAccessPhase, isPlatformJourneyEnabled]);

    useMylounge();

    if (!isLoading && (myLoungeError || !hasOpenCampaigns)) {
        return <Error />;
    }

    // TODO: check rendering count
    return (
        hasOpenCampaigns && (
            <OnImagesLoaded onLoaded={onImagesLoaded}>
                <MyLoungeWrapper flashMessages={flashMessages} />
            </OnImagesLoaded>
        )
    );
};

export default MyLounge;
